import React from "react";
import { Link } from "react-router-dom";

// Sample Data - Replace images with your actual assets
const categories = [
    {
        id: 1,
        title: "Photo Embroidery",
        image: "images/coll1.webp",
        link: "/photo-embroidery"
    },
    {
        id: 2,
        title: "Hoop Embroidery",
        image: "images/coll2.webp",
        link: "/hoop-embroidery"
    },
    {
        id: 3,
        title: "Hand Crafted Accessories",
        image: "images/coll3.webp",
        link: "/accessories"
    },
];

const CollectionCard = ({ category }) => {
    return (
        <Link to={category.link} className="col-card" style={{ textDecoration: 'none' }}>
            <div className="col-image-frame">

                {/* The Image Container */}
                <div className="col-img-wrapper">
                    <img src={category.image} alt={category.title} className="col-img" />
                    {/* Shine Effect Overlay */}
                    <div className="col-shine"></div>

                    {/* Hover Overlay */}
                    <div className="col-hover-overlay">
                        <span className="col-hover-text">Click for More</span>
                    </div>
                </div>
            </div>

            {/* Cursive Text */}
            <h3 className="col-cursive-title">
                {category.title}
                <span className="col-underline"></span>
            </h3>
        </Link>
    );
};

export default function Collections() {
    return (
        <section className="col-section">
            {/* Floating Leaf Background */}
            <div className="col-leaf-container">
                <img src="images/leaf.webp" alt="" className="col-leaf leaf-1" />
                <img src="images/leaf.webp" alt="" className="col-leaf leaf-2" />
                <img src="images/leaf.webp" alt="" className="col-leaf leaf-3" />
                <img src="images/leaf.webp" alt="" className="col-leaf leaf-4" />
                <img src="images/leaf.webp" alt="" className="col-leaf leaf-5" />
                <img src="images/leaf.webp" alt="" className="col-leaf leaf-6" />
            </div>

            <div className="col-container">

                {/* Header Section */}
                <div className="col-header">
                    <span className="col-tiny-tag">ESTD. 2025</span>
                    <h2 className="col-main-heading">
                        Have a Glance at our <span className="highlight-script">Collection</span>
                    </h2>
                    <div className="col-separator">
                        <span className="dot"></span><span className="line"></span><span className="dot"></span>
                    </div>
                    <p className="col-description">
                        Explore our pillars of creation. From capturing memories in thread
                        to crafting timeless accessories, every piece tells a story.
                    </p>
                </div>

                {/* Grid Section */}
                <div className="col-grid">
                    {categories.map((cat) => (
                        <CollectionCard key={cat.id} category={cat} />
                    ))}
                </div>

            </div>
        </section>
    );
}